
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)

export default class {
  constructor({ selector }) {
    this.selector = selector instanceof HTMLElement ? selector : document.querySelector(selector)
    this.theme = document.querySelector('body').dataset.theme
    this.color = {
      'dark': '#ffffff',
      'light': '#35393a'
    }
    //Methods   
    // console.log(this.selector)
    if (this.selector) {
      this.wrapper = this.selector.closest(".roll__wrapper")
      this.link = this.wrapper.querySelector('a')
      this.init()
    }
  }

  init() {
    let that = this
    let direction = 1  // 1 = forward, -1 = backward scroll
    ScrollTrigger.create({
      id: "rollTrigger",
      trigger: document.querySelector('[data-scroll-container]'),
      onUpdate(self) {
        if (self.direction !== direction) {
          direction *= -1
          // that.wrapper.classList.toggle("reverse")
          // if(direction == -1)
          //   gsap.set(that.wrapper.querySelectorAll(".roll"), { animationDirection: 'alternate-reverse' })
          // else  
          //   gsap.set(that.wrapper.querySelectorAll(".roll"), { animationDirection: 'alternate' })

        }
      }
    })

    if (this.link) {
      this.link.addEventListener('mouseenter', this.onMouseEnter.bind(this), false)
      this.link.addEventListener('mouseleave', this.onMouseLeave.bind(this), false)
    }
  }

  onResize() {

  }

  onMouseEnter(event) {
    this.wrapper.style.setProperty('--roll-color', this.color[document.querySelector('body').dataset.theme])
  }

  onMouseLeave(event) {
    this.wrapper.style.setProperty('--roll-color', 'rgba(69, 74, 75, 0.5)')
  }

  removeEventListener() {
    // window.removeEventListener("resize", this.onResize.bind(this))
    //
    if (this.link) {
      this.link.removeEventListener('mouseenter', this.onMouseEnter.bind(this), false)
      this.link.removeEventListener('mouseleave', this.onMouseLeave.bind(this), false)
    }
  }

  destroy() {
    this.selector && this.removeEventListener()
    //Kill animation
    // ScrollTrigger.getById("rollTrigger").kill(true)

  }
}

